import { render, staticRenderFns } from "./HistoryDrive.vue?vue&type=template&id=636071fa&scoped=true&"
import script from "./HistoryDrive.vue?vue&type=script&lang=js&"
export * from "./HistoryDrive.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDrive.vue?vue&type=style&index=0&id=636071fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636071fa",
  null
  
)

export default component.exports